const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || '/api',
  companyName: process.env.REACT_APP_COMPANY_NAME || 'AI RFQ Center',
  productName: process.env.REACT_APP_PRODUCT_NAME || 'AI RFQ Center',
  productShortName: process.env.REACT_APP_PRODUCT_SHORT_NAME || 'RFQ Center',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || '',
  copyright: process.env.REACT_APP_COPYRIGHT || '',
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#0284c7',
};

export default config;
